import { GeneralIntegrationStatus } from '@/_shared/types';

export enum ProviderEnum {
  AZURE = 'azurerm',
  M365 = 'm365',
}

export type Provider = `${ProviderEnum}`;

export type Providers = {
  key: Provider;
  value: string;
}[];

export type ProviderIntegrationStatus = {
  integrationId: string;
  name: string;
  status: GeneralIntegrationStatus;
  enabled: boolean;
  key: Provider;
  failureReason: null;
  isDataReliable: boolean;
  totalActiveInstances: number;
};

export enum ProviderStatus {
  NOT_ENABLED = 'NOT_ENABLED',
  ERROR = 'ERROR',
  NOT_CONFIGURED = 'NOT_CONFIGURED',
}
